import QrCode from "../images/qrCode.png";

const AlreadyInstalled = () => {
	return (
		<div className="flex items-center justify-center flex-col">
			<div>Приложение уже было установлено</div>
			<div>
				Необходимо перезагрузить телевизор и оно отобразится в списке приложений
			</div>
			<div>
				Если приложение не появляется, обратитесь в поддержку используя QR-код
			</div>

			<img src={QrCode} alt={"TVOЁ"} width={140} />
		</div>
	);
};

export default AlreadyInstalled;
